module.exports = __webpack_public_path__ + "media/images/icons/moon-11300f2d62f790d960d9750658cbd47f.svg";